var _style, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileAnimals = function SvgCategoryMobileAnimals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_animals_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_animals_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_animals_svg__st0",
    d: "M24.3 32.8c.1.1 2 1.5 3.9.6.2-.1 1.2-.5 1.6-1.5.7-1.5-.4-3.2-.9-4.1-1.4-2.2-3.5-3.3-4.7-3.8M24 32.8c-.1.1-2 1.5-3.9.6-.2-.1-1.2-.5-1.6-1.5-.7-1.5.4-3.2.9-4.1 1.4-2.2 3.5-3.3 4.7-3.8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.32 20.989 18.54)",
    className: "category_mobile_animals_svg__st0",
    cx: 21,
    cy: 18.5,
    rx: 2,
    ry: 3.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.32 16.438 23.947)",
    className: "category_mobile_animals_svg__st0",
    cx: 16.4,
    cy: 23.9,
    rx: 1.8,
    ry: 2.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-76.679 27.008 18.397)",
    className: "category_mobile_animals_svg__st0",
    cx: 27,
    cy: 18.4,
    rx: 3.1,
    ry: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-76.679 31.556 23.817)",
    className: "category_mobile_animals_svg__st0",
    cx: 31.6,
    cy: 23.8,
    rx: 2.7,
    ry: 1.8
  })));
};
export default SvgCategoryMobileAnimals;